import { ResponsePageable } from './../../model/cliente/pageable/responsePageable.model';
import { TipoConteudoModel } from './../../model/caixa/tipoconteudo.model';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable()
export class TipoConteudoService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpCliente: HttpClient) { }

  getTiposConteudos(page: number, size: number): Observable<ResponsePageable> {
    return this.httpCliente.get<ResponsePageable> (this.apiURL + `/view/tipo-conteudos?page=${page}&size=${size}`, this.httpOptions);
  }

  getTiposRegistros(): Observable<Array<TipoConteudoModel>> {
    return this.httpCliente.get<Array<TipoConteudoModel>>(this.apiURL + '/view/tipo-conteudo-unico', this.httpOptions);
  }

  addTipoConteudo(tipoConteudo: TipoConteudoModel): Observable<TipoConteudoModel> {
    return this.httpCliente.post<TipoConteudoModel> (this.apiURL + '/add/criar-tipo-conteudo', tipoConteudo, this.httpOptions);
  }

  editarTipoConteudo(tipoConteudo: TipoConteudoModel): Observable<TipoConteudoModel> {
    return this.httpCliente.put<TipoConteudoModel>(this.apiURL + '/edit/tipo-conteudo', tipoConteudo, this.httpOptions);
  }

  deleteTipoConteudo(idTipo: Number) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));
    return this.httpCliente.delete(this.apiURL + `/delete/tipo-conteudo/${idTipo}`, { headers, responseType: 'text' });
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/caixa/tipo-conteudo.service.ts